export interface NodeRenderer {
    render(node: Node): any;
}